import { AppRoutes, SearchParams } from '@constants';
import { guestListPath, isGuestShare } from './guestShare';

export const isSamePage = (locationPathname: string, appRoute: string) =>
  locationPathname.includes(appRoute);

export const candidateDetailsPath = (
  candidateId: string,
  listSearch: string,
  listRoute = AppRoutes.CANDIDATES,
) => {
  const view = listSearch.replace(/^\?/, '');

  return `${listBase(listRoute)}/${candidateId}${view ? `?v=${encodeURIComponent(view)}` : ''}`;
};

export const candidatesListPath = (
  detailsSearch: string,
  listRoute = AppRoutes.CANDIDATES,
) => {
  const view = new URLSearchParams(detailsSearch).get('v');

  return `${listBase(listRoute)}${view ? `?${view}` : ''}`;
};

/** A guest moves between the same pages under their share link. */
const listBase = (listRoute: string) =>
  isGuestShare() ? guestListPath() : `/${listRoute}`;

export const sharePath = (submissionId: string) =>
  `/${AppRoutes.SHARE}?${SearchParams.SUBMISSION}=${encodeURIComponent(submissionId)}`;
